import { getClassifiers } from '@dealstack/frontend/shared/dataExchange/services/valuations.service';
import { ClassifierRes, ClassifierType } from '@dealstack/shared/lib/generated';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { useQuery } from '@tanstack/react-query';

const emptyList: ClassifierRes[] = [];

export const useValuationClassifiers = () => {
	const { data: classifiersRaw, ...queryResult } = useQuery({
		queryKey: [API_PATHS.CLASSIFIER_GET],
		queryFn: ({ signal }) => getClassifiers(signal),
	});

	const classifiers = classifiersRaw?.payload ?? emptyList;

	const valuationClassifiers = classifiers.filter(
		(classifier) => classifier.classifiedType === ClassifierType.VALUATION
	);

	const valuationInputClassifiers = classifiers.filter(
		(classifier) => classifier.classifiedType === ClassifierType.VALUATION_INPUT
	);

	return {
		valuationClassifiers,
		valuationInputClassifiers,
		...queryResult, // Includes isLoading, error, etc. from useQuery
	};
};
